// 用戶答題模塊
export default {
  UserAnswer: {
    YouHaveAlreadyAnswered: '您之前已經回答了',
    Question: '題',
    DoYouWantToContinue: '是否繼續上次回答',
    PreviewOrPrint: '預覽或打印',
    ReAnswerQuestions: '重新答題',
    ContinueAnsweringQuestions: '繼續答題',
    TheQuestionnaireWillBeOpen: '此問卷將開放，請到時再打開此頁面！',
    EnterQuestionnairePassword: '請輸入問卷密碼',
    EnterPassword: '請輸入密碼',
    Determine: '確定',
    ShareTo: '分享至',
    ClickToView: '點擊查看',
    Statistics: '統計',
    ShareOnWeChatMoments: '分享到微信朋友圈',
    WantToContinue: '您是否繼續答題',
    NoActionTaken: '若長時間未有任何操作，系統將自動提交考卷',
    SubmitTo: '提交',
    YouHaveLeftTheExam: '您已離開考試',
    Times: '次',
    Leave: '離開次數達到',
    WillBeForcedToSubmitThePaper: '次將強制交卷',
    NeedToOpenOnWeChat: '您需要在微信中打開才能參與',
    ScanQRCodeUsingWeChat: '用微信掃一掃下面的二維碼',
    CopyThisPageAddress: '你可復制本頁面地址，通過在微信中發送消息來打開',
    WeChatLoginRequired: '微信登錄後才能參與',
    OneClickLogin: '一鍵登錄',
    Loading: '正在加載...',
    RateTheOptions: '請為選項打分',
    SelectOptions: '請選擇選項',
    SelectDate: '請選擇日期',
    SortAllOptions: '請對所有選項進行排序',
    SelectedPosition: '請選擇位置',
    EnsureCompleteAnswers: '請確保答案完整',
    Timing: '請選擇時間',
    ChooseAnOption: '請選擇一個選項',
    CheckTheAnswers: '請檢查答案',
    InputContent: '請輸入內容',
    UploadFiles: '請上傳文件',
    SelectSpecificGravity: '請選擇比重',
    StatisticsPageToBeImproved: '統計頁面待完善',
    UploadFailed: '上傳失敗！',
    Submitting: '正在提交...',
    Prompt: '提示',
    TheAnswerIsNotRecorded: '當前為預覽頁面，答案不被記錄。',
    IsOver: '結束了',
    NothingInTheWorld: '這裏什麽也沒有~',
    Staging: '暫存',
    ScanQRCodeToAnswerQuestions: '掃碼答題',
    Report: '舉報',
    DongfangAixueProvidesSupport: '東方艾學提供支持',
    Print: '打印',
    DataPreparationInProgress: '數據準備中，預計5分鐘後完成。前往',
    CanViewProgress: '可查看進度',
    MyDownload: '我的下載',
    QuotaIsFull: '配額已滿',
    SuccessfullyStaged: '暫存成功',
    PleaseEnter: '請輸入',
    Other: '其他',
    PleaseSelect: '請選擇',
    Small: '小',
    Middle: '中',
    TotalSpecificGravity: '比重總和',
    Big: '大',
    Year: '年',
    Month: '月',
    Day: '日',
    GetLocation: '點擊獲取地理位置',
    YourLocation: '您的位置',
    SearchAddress: '輸入關鍵字搜索地址',
    Clear: '清除',
    SelectAProvince: '請選擇省份',
    SelectACity: '請選擇城市',
    SelectADistrict: '請選擇區/縣',
    DetailedAddress: '詳情地址',
    UploadFileImages: '上傳文件圖片',
    UploadFilesWithin10M: '選擇上傳文件(10M以內)',
    TheFileSizeCannotExceed10MB: '上傳文件大小不能超過 10MB!',
    MaximumNumberOfTimes: '已達到文件上傳最大次數',
    FailedToUploadFile: '上傳文件失敗',
    SelectCascadingOption: '請選擇級聯選項',
    SelectTheFollowingImage: '請選擇以下圖片',
    MaximumSelection: '選項最多選擇',
    Options: '項',
    MinimalSelection: '選項最少選擇',
    CheckTheAnswers: '請檢查答案',
    OnlineQuestionnaire: '在線問卷',
    ExplanationScores: '得分解釋：',
    ExplanationScoresA: '如果您得分為',
    ExplanationScoresB: '表示您對該量表的',
    ExplanationScoresC: '維度有輕微的偏好，但您基本上保持平衡。',
    ExplanationScoresD: '表示您對該量表的',
    ExplanationScoresE: '維度有中度的偏好，您將更容易在偏向該維度的教學環境中學習。',
    ExplanationScoresF: '表示您對該量表的',
    ExplanationScoresG: '維度有強烈的偏好。在不支持該偏好的環境中，您可能會面臨學習上的真正困難。'
  },
};